/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.judge.master
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_judge_judge_pb = require('../../../../io/codedrills/proto/judge/judge_pb.js')

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js')

var io_codedrills_proto_content_pagination_pb = require('../../../../io/codedrills/proto/content/pagination_pb.js')

var io_codedrills_proto_user_candidate_pb = require('../../../../io/codedrills/proto/user/candidate_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.judge = {};
proto.io.codedrills.proto.judge.master = require('./judge_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest,
 *   !proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse>}
 */
const methodInfo_JudgeService_CreateSolutionTemplate = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.createSolutionTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/CreateSolutionTemplate',
      request,
      metadata || {},
      methodInfo_JudgeService_CreateSolutionTemplate,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.createSolutionTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/CreateSolutionTemplate',
      request,
      metadata || {},
      methodInfo_JudgeService_CreateSolutionTemplate);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmitCodeRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmitCodeResponse>}
 */
const methodInfo_JudgeService_SubmitCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmitCodeResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmitCodeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.SubmitCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmitCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submitCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmitCode',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmitCode,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.SubmitCodeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submitCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmitCode',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmitCode);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmitAnswerRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmitAnswerResponse>}
 */
const methodInfo_JudgeService_SubmitAnswer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmitAnswerResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.SubmitAnswerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submitAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmitAnswer',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmitAnswer,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submitAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmitAnswer',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmitAnswer);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.FetchAnswerRequest,
 *   !proto.io.codedrills.proto.judge.master.FetchAnswerResponse>}
 */
const methodInfo_JudgeService_FetchAnswer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.FetchAnswerResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.FetchAnswerResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.FetchAnswerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.FetchAnswerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.fetchAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/FetchAnswer',
      request,
      metadata || {},
      methodInfo_JudgeService_FetchAnswer,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.FetchAnswerResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.fetchAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/FetchAnswer',
      request,
      metadata || {},
      methodInfo_JudgeService_FetchAnswer);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.DeleteAnswersRequest,
 *   !proto.io.codedrills.proto.judge.master.DeleteAnswersResponse>}
 */
const methodInfo_JudgeService_DeleteAnswers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.DeleteAnswersResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.DeleteAnswersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.deleteAnswers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/DeleteAnswers',
      request,
      metadata || {},
      methodInfo_JudgeService_DeleteAnswers,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.deleteAnswers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/DeleteAnswers',
      request,
      metadata || {},
      methodInfo_JudgeService_DeleteAnswers);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmissionStatusRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmissionStatusResponse>}
 */
const methodInfo_JudgeService_SubmissionStatus = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmissionStatusResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.SubmissionStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submissionStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionStatus',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionStatus,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submissionStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionStatus',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionStatus);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse>}
 */
const methodInfo_JudgeService_SubmissionHistory = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submissionHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionHistory',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionHistory,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submissionHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionHistory',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionHistory);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest,
 *   !proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse>}
 */
const methodInfo_JudgeService_TestSubmissionHistory = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.testSubmissionHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/TestSubmissionHistory',
      request,
      metadata || {},
      methodInfo_JudgeService_TestSubmissionHistory,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.testSubmissionHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/TestSubmissionHistory',
      request,
      metadata || {},
      methodInfo_JudgeService_TestSubmissionHistory);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest,
 *   !proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse>}
 */
const methodInfo_JudgeService_UserAttemptedProblems = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.userAttemptedProblems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/UserAttemptedProblems',
      request,
      metadata || {},
      methodInfo_JudgeService_UserAttemptedProblems,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.userAttemptedProblems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/UserAttemptedProblems',
      request,
      metadata || {},
      methodInfo_JudgeService_UserAttemptedProblems);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmissionRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmissionResponse>}
 */
const methodInfo_JudgeService_Submission = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmissionResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmissionRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmissionResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.SubmissionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmissionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submission =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/Submission',
      request,
      metadata || {},
      methodInfo_JudgeService_Submission,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.SubmissionResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submission =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/Submission',
      request,
      metadata || {},
      methodInfo_JudgeService_Submission);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmissionStatsRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmissionStatsResponse>}
 */
const methodInfo_JudgeService_SubmissionStats = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmissionStatsResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.SubmissionStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submissionStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionStats',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionStats,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submissionStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionStats',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionStats);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest,
 *   !proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse>}
 */
const methodInfo_JudgeService_AllContestSubmissionSummary = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.allContestSubmissionSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/AllContestSubmissionSummary',
      request,
      metadata || {},
      methodInfo_JudgeService_AllContestSubmissionSummary,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.allContestSubmissionSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/AllContestSubmissionSummary',
      request,
      metadata || {},
      methodInfo_JudgeService_AllContestSubmissionSummary);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.ServerTimeRequest,
 *   !proto.io.codedrills.proto.judge.master.ServerTimeResponse>}
 */
const methodInfo_JudgeService_ServerTime = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.ServerTimeResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.ServerTimeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.ServerTimeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.ServerTimeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.ServerTimeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.serverTime =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/ServerTime',
      request,
      metadata || {},
      methodInfo_JudgeService_ServerTime,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.ServerTimeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.serverTime =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/ServerTime',
      request,
      metadata || {},
      methodInfo_JudgeService_ServerTime);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.SubmissionStatusRequest,
 *   !proto.io.codedrills.proto.judge.master.SubmissionStatusResponse>}
 */
const methodInfo_JudgeService_SubmissionStatusListener = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.SubmissionStatusResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse>}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.submissionStatusListener =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionStatusListener',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionStatusListener);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse>}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.submissionStatusListener =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/SubmissionStatusListener',
      request,
      metadata || {},
      methodInfo_JudgeService_SubmissionStatusListener);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.RejudgeRequest,
 *   !proto.io.codedrills.proto.judge.master.RejudgeResponse>}
 */
const methodInfo_JudgeService_Rejudge = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.RejudgeResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.RejudgeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.RejudgeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.RejudgeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.RejudgeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.rejudge =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/Rejudge',
      request,
      metadata || {},
      methodInfo_JudgeService_Rejudge,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.RejudgeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.rejudge =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/Rejudge',
      request,
      metadata || {},
      methodInfo_JudgeService_Rejudge);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.FetchRejudgeRequest,
 *   !proto.io.codedrills.proto.judge.master.FetchRejudgeResponse>}
 */
const methodInfo_JudgeService_FetchRejudge = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.FetchRejudgeResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.FetchRejudgeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.fetchRejudge =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/FetchRejudge',
      request,
      metadata || {},
      methodInfo_JudgeService_FetchRejudge,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.fetchRejudge =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/FetchRejudge',
      request,
      metadata || {},
      methodInfo_JudgeService_FetchRejudge);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest,
 *   !proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse>}
 */
const methodInfo_JudgeService_ContestSubmissions = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.contestSubmissions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/ContestSubmissions',
      request,
      metadata || {},
      methodInfo_JudgeService_ContestSubmissions,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.contestSubmissions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/ContestSubmissions',
      request,
      metadata || {},
      methodInfo_JudgeService_ContestSubmissions);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest,
 *   !proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse>}
 */
const methodInfo_JudgeService_UploadContestSubmissions = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.uploadContestSubmissions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/UploadContestSubmissions',
      request,
      metadata || {},
      methodInfo_JudgeService_UploadContestSubmissions,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.uploadContestSubmissions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/UploadContestSubmissions',
      request,
      metadata || {},
      methodInfo_JudgeService_UploadContestSubmissions);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.AllSubmissionsRequest,
 *   !proto.io.codedrills.proto.judge.master.AllSubmissionsResponse>}
 */
const methodInfo_JudgeService_AllSubmissions = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.AllSubmissionsResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.AllSubmissionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.allSubmissions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/AllSubmissions',
      request,
      metadata || {},
      methodInfo_JudgeService_AllSubmissions,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.allSubmissions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/AllSubmissions',
      request,
      metadata || {},
      methodInfo_JudgeService_AllSubmissions);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest,
 *   !proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse>}
 */
const methodInfo_JudgeService_GetProblemSubmissionsAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.getProblemSubmissionsAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/GetProblemSubmissionsAdmin',
      request,
      metadata || {},
      methodInfo_JudgeService_GetProblemSubmissionsAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.getProblemSubmissionsAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/GetProblemSubmissionsAdmin',
      request,
      metadata || {},
      methodInfo_JudgeService_GetProblemSubmissionsAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest,
 *   !proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse>}
 */
const methodInfo_JudgeService_GetSubmissionPreviewsByIds = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse,
  /** @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.judge.master.JudgeServiceClient.prototype.getSubmissionPreviewsByIds =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/GetSubmissionPreviewsByIds',
      request,
      metadata || {},
      methodInfo_JudgeService_GetSubmissionPreviewsByIds,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.judge.master.JudgeServicePromiseClient.prototype.getSubmissionPreviewsByIds =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.judge.master.JudgeService/GetSubmissionPreviewsByIds',
      request,
      metadata || {},
      methodInfo_JudgeService_GetSubmissionPreviewsByIds);
};


module.exports = proto.io.codedrills.proto.judge.master;

